// Parse/format as local calendar dates (not UTC) so picking "6 Oct" never
// shifts to "5 Oct" for timezones behind UTC.
export function parseLocalDate(value: string): Date | undefined {
  if (!value) return undefined;
  const parts = value.split("-").map(Number);
  if (parts.length < 3 || parts.some(isNaN)) return undefined;
  const [y, m, d] = parts as [number, number, number];
  return new Date(y, m - 1, d);
}

export function formatLocalDate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function formatDateLabel(date: Date): string {
  return date.toLocaleDateString("id-ID", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

// Formats an ISO timestamp in WIB; returns the raw string if it can't be parsed.
export function formatDateWIB(
  value: string,
  options: Intl.DateTimeFormatOptions = { dateStyle: "medium" },
): string {
  try {
    return new Intl.DateTimeFormat("id-ID", {
      ...options,
      timeZone: "Asia/Jakarta",
    }).format(new Date(value));
  } catch {
    return value;
  }
}
